module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-7-0add9aa996eae6ae4976e3d165f73b61.svg";